export default {"src":"/_next/static/media/premium30millionsamis.10fcd1c4.svg","height":34,"width":41,"blurWidth":0,"blurHeight":0};